module.exports = __webpack_public_path__ + "img/Windfish-LinkKeys.8c0a5056.jpg";